export default [
  // {
  //   "statusName": "TotalEmployees",
  //   "status": "Total Employees",
  //   "bgColor": "#fff",
  //   "totalCount": 0,
  //   "statusId": [32],
  //   "darkColor": "#b6e5b9",
  // },
  {
    statusName: 'orders',
    status: 'Total Registration',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [24, 30, 31, 40],
    darkColor: '#a3cbff'
  },
  {
    statusName: 'Total',
    status: 'Total Sessions',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [24, 30, 31, 40],
    darkColor: '#a3cbff'
  },
  {
    statusName: 'Cancelled',
    status: 'Cancelled',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22],
    darkColor: '#c7c7c7'
  },
  {
    statusName: 'NotAttended',
    status: 'Not Attended',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22],
    darkColor: '#ffcece'
  },
  {
    statusName: 'Attended',
    status: 'Sessions Completed',
    bgColor: '#fff',
    totalCount: 0,
    statusId: [22],
    darkColor: '#f0b0e4'
  },
  {
    statusName: 'NewAppointment',
    status: 'Upcoming Sessions',
    bgColor: '#f8d8d8',
    totalCount: 0,
    statusId: [22, 29, 30, 31],
    darkColor: '#ffcece',
    showInEmployees: true
  }
];
